import { useState } from "react";
import { Navbar } from "@/components/Navbar";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";
import { Check, Loader2, Sparkles } from "lucide-react";

const PERKS = [
  "Unlimited wardrobe uploads with AI tagging",
  "AI outfit pairing with coordination scores",
  "Your own personal AI stylist, on call 24/7",
  "Save unlimited looks to your Lookbook",
  "Filter fits by occasion — casual to formal",
];

export default function Subscribe() {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);

  const subscribe = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/payments/checkout", { origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error("Could not start checkout");
      setLoading(false);
    }
  };

  return (
    <div className="bg-bg0 min-h-screen">
      <Navbar />
      <section className="max-w-[1100px] mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <div className="ep-fade-up">
            <div className="overline mb-4 text-volt">Membership</div>
            <h1 className="font-display uppercase text-5xl md:text-6xl font-bold tracking-tighter leading-none">
              Unlock your<br />personal stylist.
            </h1>
            <p className="text-epsub mt-6 leading-relaxed max-w-md">
              {user?.name ? `${user.name}, one` : "One"} membership unlocks the full Eternal engine —
              AI pairing, unlimited closet, and a stylist that actually gets your vibe.
            </p>
            <ul className="mt-8 space-y-3">
              {PERKS.map((p, i) => (
                <li key={i} className="flex items-start gap-3 text-sm" data-testid={`perk-${i}`}>
                  <span className="mt-0.5 text-volt"><Check size={16} strokeWidth={2.5} /></span>
                  <span className="text-white/90">{p}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="ep-card p-10 volt-glow" data-testid="plan-card">
            <div className="overline text-volt">Eternal Membership</div>
            <div className="flex items-end gap-2 mt-4">
              <span className="font-display text-7xl font-bold tracking-tighter">$9.99</span>
              <span className="text-epsub mb-3 font-mono-accent text-sm">/ month</span>
            </div>
            <p className="text-epmuted text-sm mt-2">Cancel anytime. Billed monthly.</p>

            <button
              onClick={subscribe}
              disabled={loading}
              data-testid="subscribe-btn"
              className="ep-btn w-full mt-8 inline-flex items-center justify-center gap-2 bg-volt text-black py-4 text-sm font-bold uppercase tracking-widest hover:bg-volt-hover disabled:opacity-60"
            >
              {loading ? <><Loader2 size={16} className="animate-spin" /> Redirecting…</> : <><Sparkles size={16} /> Start Membership</>}
            </button>
            <p className="text-center text-epmuted text-xs mt-4 font-mono-accent">
              Secure checkout via Stripe · Test card 4242 4242 4242 4242
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
